import type { CostsAndFees, UnitSelector } from '@/src/types/costAndFees.type';

export function normalizeUnitIdentifier(value: string | null | undefined): string {
  if (!value) return '';

  return value
    .trim()
    .toLowerCase()
    .replace(/^unit[\s#-]*/, '')
    .replace(/[^a-z0-9]/g, '')
    .replace(/\d+/g, (digits) => digits.replace(/^0+(?=\d)/, ''));
}

export function findUnitCostSelector(
  costsData: CostsAndFees,
  unitName: string | null | undefined,
  unitModelId: string | null | undefined,
  unitBeds: number | undefined,
): UnitSelector | undefined {
  const identifiers = [unitName, unitModelId].map(normalizeUnitIdentifier).filter(Boolean);
  const rawIdentifiers = [unitName, unitModelId].filter((value): value is string => Boolean(value));

  return costsData.selectors.units.find((unitSelector) => {
    if (rawIdentifiers.includes(unitSelector.unitZpid)) return true;
    if (unitBeds !== undefined && unitSelector.numBeds !== unitBeds) return false;

    const selectorIdentifier = normalizeUnitIdentifier(unitSelector.selector.displayName);
    return selectorIdentifier !== '' && identifiers.includes(selectorIdentifier);
  });
}
